<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Notificaciones - Envío Manual</h4>
            <div class="small text-muted">Envío manual de notificaciones a usuarios</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>          
          <b-col lg="6" md="6">                    
            <b-row>          
              <b-col lg="3" md="6">
                <b-form-group label="Medio">
                  <b-form-select v-model="crud.form.method" :options="arr.select.methods"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="3" md="6" v-if="crud.form.method != 'internal' && crud.form.method != 'sms'">
                <b-form-group label="Tipo de Usuario">
                  <b-form-select v-model="crud.form.type" :options="filteredTypes"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="12" v-if="crud.form.method == 'sms'">
                <b-alert show variant="danger">
                  <b-icon icon="exclamation-triangle-fill" class="mr-1"></b-icon>
                  <b>Sin soporte.</b> El canal SMS ya no está soportado y no puede utilizarse para el envío manual.
                </b-alert>
              </b-col>
              <b-col lg="6" md="12" v-if="crud.form.method != 'sms'">
                <FindObject type="staff"
                            @select-object="loadStaff($event)"
                            :valueID="crud.form.staff_id"
                            render="search"
                            v-if="crud.form.method == 'internal' || ((crud.form.method == 'email' || crud.form.method == 'whatsapp') && crud.form.type == 'staff')"
                            :key="'notifications_staff_internal_'+crud.form.staff_id"/>

                <FindObject type="staff-subscription-push"
                            @select-object="loadStaff($event)"
                            :valueID="crud.form.staff_id"
                            render="search"
                            v-if="crud.form.method == 'push' && crud.form.type == 'staff'"
                            :key="'notifications_staff_'+crud.form.staff_id"/>

                <FindObject type="customers-subscription-push"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customer_id"
                            render="search"
                            v-if="crud.form.method == 'push' && crud.form.type == 'customer'"
                            :key="'notifications_customer_'+crud.form.customer_id"/>

                <FindObject type="suppliers-subscription-push"
                            @select-object="loadSuppliers($event)"
                            :valueID="crud.form.supplier_id"
                            render="search"
                            v-if="crud.form.method == 'push' && crud.form.type == 'supplier'"
                            :key="'notifications_supplier_'+crud.form.supplier_id"/>

                <FindObject type="customers"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customer_id"
                            render="search"
                            v-if="(crud.form.method == 'email' || crud.form.method == 'whatsapp') && crud.form.type == 'customer'"
                            :key="'notifications_customer_email_'+crud.form.customer_id"/>

                <FindObject type="suppliers"
                            @select-object="loadSuppliers($event)"
                            :valueID="crud.form.supplier_id"
                            render="search"
                            v-if="(crud.form.method == 'email' || crud.form.method == 'whatsapp') && crud.form.type == 'supplier'"
                            :key="'notifications_supplier_email_'+crud.form.supplier_id"/>

                <b-form-group label="Email"
                              v-if="crud.form.method == 'email' && crud.form.type == 'external'">
                  <b-form-input type="email" v-model="crud.form.email" placeholder="email@dominio.com"></b-form-input>
                </b-form-group>

                <b-form-group label="Teléfono"
                              description="Cod país [sin el signo] + cod área [sin el 0] + nro cel [sin el 15]. Con o sin el 9 de móvil, se ajusta automáticamente."
                              v-if="crud.form.method == 'whatsapp' && crud.form.type == 'external'">
                  <b-form-input type="number" v-model="crud.form.phone" placeholder="543416908870"></b-form-input>
                </b-form-group>
              </b-col>
              <template v-if="crud.form.method != 'sms'">
                <b-col lg="6" md="6" v-if="crud.form.method == 'whatsapp'">
                  <b-form-group label="Instancia de Whatsapp">
                    <b-form-select v-model="crud.form.notifications_whatsapp_id" :options="whatsappInstanceOptions"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col lg="6" md="6" v-if="crud.form.method == 'whatsapp'">
                  <b-form-group label="Plantilla" description="'Texto libre' solo funciona si el destinatario te escribió en las últimas 24hs">
                    <b-form-select v-model="crud.form.whatsapp_template_id" :options="whatsappTemplateOptions"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col lg="12" v-if="crud.form.method != 'whatsapp'">
                  <b-form-group label="Título">
                    <b-form-input v-model="crud.form.title" placeholder="Título"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="12" v-if="crud.form.method != 'whatsapp' || !crud.form.whatsapp_template_id">
                  <b-form-group label="Mensaje">
                    <b-textarea v-model="crud.form.message" placeholder="Mensaje" rows="3"></b-textarea>
                  </b-form-group>
                </b-col>
                <b-col lg="12" v-if="crud.form.method == 'whatsapp' && crud.form.whatsapp_template_id">
                  <b-card bg-variant="light" class="mb-3">
                    <div class="small text-muted mb-2">{{ selectedWhatsappTemplate ? selectedWhatsappTemplate.body : '' }}</div>
                    <b-form-group v-for="(param, index) in crud.form.whatsapp_template_params"
                                  :key="'whatsapp_template_param_'+index"
                                  :label="'Parámetro {{' + (index + 1) + '}}'"
                                  class="mb-2">
                      <b-form-input v-model="crud.form.whatsapp_template_params[index]"></b-form-input>
                    </b-form-group>
                  </b-card>
                </b-col>

                <b-col lg="12" v-if="crud.form.method != 'whatsapp'">
                  <b-form-group label="URL" description="URL de redireccionamiento en el click">
                    <b-form-input v-model="crud.form.url" placeholder="URL"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="12" md="12">
                  <hr>
                </b-col>
                <b-col lg="6" md="6">
                  <b-button variant="outline-secondary" class="pull-left" @click="clean()">Limpiar</b-button>
                </b-col>
                <b-col lg="6" md="6">
                  <b-button variant="dark" class="pull-right" @click="send()">Enviar</b-button>
                </b-col>
              </template>
            </b-row>               
          </b-col>
          <b-col lg="6" md="6">   
            <b-form-group label="Resultado">  
              <prism-editor v-model="crud.form.result" language="json" class="notifications-send-manual-result" :readonly="true"></prism-editor>            
            </b-form-group>          
          </b-col>          
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'

  import FindObject from '@/components/inc/find/findObject'
  import PrismEditor from 'vue-prism-editor'
  import "prismjs";
  import "prismjs/themes/prism.css";
  import 'prismjs/components/prism-json';

  export default {
    components: {          
      FindObject,
      PrismEditor,
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'manualSend',
          elements: {}
        }, 
        crud: {
          form: {
            method: 'email',
            source: 'SYSTEM',
            type: 'external',
            title: '',
            message: '',
            url: '',
            staff: null,
            staff_id: 0,
            customer: null,
            customer_id: 0,
            supplier: null,
            supplier_id: 0,
            email: '',
            phone: '',
            notifications_whatsapp_id: 0,
            whatsapp_template_id: '',
            whatsapp_template_params: [],
            result: ''
          }
        },
        whatsappInstances: [],
        whatsappTemplates: [],
        arr: {
          select: {
            methods: [
              { value: 'email', text: 'EMAIL', disabled: false },
              { value: 'push', text: 'PUSH', disabled: false },
              { value: 'internal', text: 'INTERNA', disabled: false },
              { value: 'whatsapp', text: 'WHATSAPP', disabled: false },
              { value: 'sms', text: 'SMS', disabled: false },
            ],
            types: [
              { value: 'staff', text: 'STAFF' },
              { value: 'customer', text: 'CLIENTES' },
              { value: 'supplier', text: 'PROVEEDORES' },
              { value: 'external', text: 'EXTERNO' },
            ],
          }
        }
      }
    },
    computed: {
      filteredTypes() {
        if(this.crud.form.method == 'email' || this.crud.form.method == 'whatsapp') {
          return this.arr.select.types
        }
        return this.arr.select.types.filter((item) => item.value != 'external')
      },
      whatsappInstanceOptions() {
        return this.whatsappInstances.map((item) => ({ value: item.id, text: item.name }))
      },
      whatsappTemplateOptions() {
        var options = [{ value: '', text: 'Texto libre' }]
        this.whatsappTemplates.forEach((template) => {
          options.push({ value: template.id, text: template.name + ' (' + template.status + ')' })
        })
        return options
      },
      selectedWhatsappTemplate() {
        var id = this.crud.form.whatsapp_template_id
        return this.whatsappTemplates.find((template) => template.id == id) || null
      },
      whatsappTemplateVariablesCount() {
        var template = this.selectedWhatsappTemplate
        if(!template || !template.body) return 0
        var matches = template.body.match(/\{\{\d+\}\}/g)
        return matches ? matches.length : 0
      }
    },
    watch: {
      'crud.form.method'(value) {
        if(!this.crud.form.type || (value != 'email' && value != 'whatsapp' && this.crud.form.type == 'external')) {
          this.crud.form.type = 'staff'
        }
        this.resetRecipients()
      },
      'crud.form.type'() {
        this.resetRecipients()
      },
      'crud.form.whatsapp_template_id'() {
        this.crud.form.whatsapp_template_params = new Array(this.whatsappTemplateVariablesCount).fill('')
      }
    },
    mounted () {
      this.loadWhatsappInstances()
      this.loadWhatsappTemplates()
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    methods: {
      loadWhatsappInstances() {
        serviceAPI.obtenerWhatsapp()
          .then((response) => {
            this.whatsappInstances = response.data
            if(!this.crud.form.notifications_whatsapp_id && this.whatsappInstances.length) {
              this.crud.form.notifications_whatsapp_id = this.whatsappInstances[0].id
            }
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
      },
      loadWhatsappTemplates() {
        serviceAPI.listWhatsappTemplates()
          .then((response) => {
            this.whatsappTemplates = response.data
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
      },
      loadStaff(object){
        if(object){
          this.crud.form.staff = object
          this.crud.form.staff_id = object.id        

          this.crud.form.customer = null
          this.crud.form.customer_id = 0
          this.crud.form.supplier = null
          this.crud.form.supplier_id = 0                              
        } else {
          this.crud.form.staff = null
          this.crud.form.staff_id = 0
        }
      },
      loadCustomers(object){
        if(object){
          this.crud.form.customer = object
          this.crud.form.customer_id = object.id        

          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.supplier = null
          this.crud.form.supplier_id = 0                              
        } else {
          this.crud.form.customer = null
          this.crud.form.customer_id = 0
        }        
      },
      loadSuppliers(object){
        if(object){
          this.crud.form.supplier = object
          this.crud.form.supplier_id = object.id        

          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.customer = null
          this.crud.form.customer_id = 0                              
        } else {
          this.crud.form.supplier = null
          this.crud.form.supplier_id = 0
        }
      },

      resetRecipients() {
        this.crud.form.staff = null
        this.crud.form.staff_id = 0
        this.crud.form.customer = null
        this.crud.form.customer_id = 0
        this.crud.form.supplier = null
        this.crud.form.supplier_id = 0
        this.crud.form.email = ''
        this.crud.form.phone = ''
      },

      send() {
        if(this.crud.form.method == 'sms') {
          this.$awn.alert("El canal SMS ya no está soportado.");
          return false
        }

        if(this.crud.form.method == 'internal') {
          if(!this.crud.form.staff_id) {
            this.$awn.alert("Debes seleccionar un STAFF");
            return false
          }
        } else {
          if(this.crud.form.type=='staff' && !this.crud.form.staff_id) {
            this.$awn.alert("Debes seleccionar un STAFF");
            return false
          }
          if(this.crud.form.type=='customer' && !this.crud.form.customer_id) {
            this.$awn.alert("Debes seleccionar un CLIENTE");
            return false
          }
          if(this.crud.form.type=='supplier' && !this.crud.form.supplier_id) {
            this.$awn.alert("Debes seleccionar un PROVEEDOR");
            return false
          }
          if(this.crud.form.method == 'whatsapp' && ['staff', 'customer', 'supplier'].includes(this.crud.form.type)) {
            var recipient = this.crud.form.staff || this.crud.form.customer || this.crud.form.supplier
            if(!Funciones.validarTelefonoWhatsapp(recipient && recipient.phone)) {
              this.$awn.alert("El teléfono cargado para este destinatario no es válido para Whatsapp. Corregilo desde su ficha antes de enviar.");
              return false
            }
          }
          if(this.crud.form.type=='external' && this.crud.form.method == 'email') {
            if(!this.crud.form.email) {
              this.$awn.alert("Debes ingresar un EMAIL");
              return false
            }
            if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.crud.form.email)) {
              this.$awn.alert("Debes ingresar un EMAIL válido");
              return false
            }
          }
          if(this.crud.form.type=='external' && this.crud.form.method == 'whatsapp') {
            if(!Funciones.validarTelefonoWhatsapp(this.crud.form.phone)) {
              this.$awn.alert("Debes ingresar un TELÉFONO válido (con o sin el 9 de móvil)");
              return false
            }
          }
        }

        if(this.crud.form.method == 'whatsapp') {
          if(!this.crud.form.notifications_whatsapp_id) {
            this.$awn.alert("Debes seleccionar una instancia de Whatsapp");
            return false
          }
          if(this.crud.form.whatsapp_template_id) {
            var faltaParametro = this.crud.form.whatsapp_template_params.some((param) => !param)
            if(faltaParametro) {
              this.$awn.alert("Completá todos los parámetros de la plantilla");
              return false
            }
          } else if(!this.crud.form.message) {
            this.$awn.alert("Debes ingresar un mensaje o elegir una plantilla");
            return false
          }
        }

        this.$bvModal.msgBoxConfirm('¿Confirmar el envío de la notificación?', {
          title: 'Enviar notificación',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'ENVIAR',
          cancelVariant: 'outline-dark',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'black',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = this.crud.form.method == 'internal'
              ? serviceAPI.manualSendInternal(this.crud.form)
              : serviceAPI.manualSend(this.crud.form);

            result.then((response) => { 
              loader.hide()              

              this.crud.form.result = JSON.stringify(response.data, null, 4)
              
              this.$awn.success("Notificación Enviada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })            
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },
      clean() {
        this.crud.form.method = 'internal'
        this.crud.form.source = 'SYSTEM'
        this.crud.form.type = 'staff'
        this.crud.form.title = ''
        this.crud.form.message = ''
        this.crud.form.icon = ''
        this.crud.form.url = ''   
        this.crud.form.staff = null
        this.crud.form.staff_id = 0
        this.crud.form.customer = null
        this.crud.form.customer_id = 0
        this.crud.form.supplier = null
        this.crud.form.supplier_id = 0
        this.crud.form.email = ''
        this.crud.form.phone = ''
        this.crud.form.whatsapp_template_id = ''
        this.crud.form.whatsapp_template_params = []
        this.crud.form.result = ''
      }
    }
  }
</script>
<style>
  .notifications-send-manual-result {
    height: 400px;
  }
  .notifications-send-manual-result pre {
    height: 400px;
  }  
</style>
